var map = {
	"./de.json": 95894,
	"./el.json": 94524,
	"./en.json": 44174,
	"./es.json": 46725,
	"./fr.json": 94605,
	"./hr.json": 36759,
	"./id.json": 35176,
	"./it.json": 83672,
	"./pl.json": 11029,
	"./pt-BR.json": 46040,
	"./pt.json": 37741,
	"./ro.json": 22354,
	"./ru.json": 74600,
	"./sr.json": 78912,
	"./th.json": 67549,
	"./tr.json": 79755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5432;